<script lang="ts">
import { defineComponent, h } from 'vue';

import { makeTagProps, useRender } from '../../composable';
import { CdsDivider } from '../CdsDivider';

export const componentName = 'CdsCardDivider';
export default defineComponent({
  name: componentName,
  props: {
    ...makeTagProps()
  },
  setup(props, { slots }) {
    useRender(() =>
      h(
        props.tag,
        {
          class: 'cds-card-divider'
        },
        slots.default ? slots.default() : h(CdsDivider)
      )
    );

    return {};
  }
});
</script>
